export default {
    shared: {
        noWebsite: 'Pick an active website first.',
    },
    index: {
        title: 'Landing pages',
        newDataset: 'New dataset',
        emptyIntro: 'No landing-page datasets yet. A dataset bundles one template + a slug pattern + N rows. Each row becomes one landing page.',
        emptyTemplates: "Templates live in your theme repo under {path}. They're discovered automatically when you activate a theme version.",
        createFirst: 'Create your first dataset',
        columns: {
            template: 'Template',
            slugPattern: 'Slug pattern',
            pages: 'Pages',
        },
    },
    edit: {
        newTitle: 'New landing dataset',
        saveDataset: 'Save dataset',
        created: 'Dataset created',
        confirmDelete: 'Delete dataset "{name}"? | Delete dataset "{name}" and its {n} landing page? | Delete dataset "{name}" and all {n} of its landing pages?',
        confirmDeleteRow: 'Delete landing page "{slug}"?',
        invalidRow: 'Invalid row.',
        pickTemplate: 'Pick a template…',
        noVariables: 'no variables',
        dataset: 'Dataset',
        namePlaceholder: 'Cities NL',
        template: 'Template',
        noTemplates: 'No landing templates discovered in the active theme version. Designers ship these as {path}, then activate a theme version to make them available here.',
        slugPattern: 'Slug pattern',
        // {token} etc. are filled with the literal token syntax, e.g. "{city|slug}".
        slugPatternPlaceholder: '/shopping-in-{token}',
        slugPatternHint: 'Must start with /. Tokens: {slugified} (slugified) or {raw} (kept as-is).',
        metaTitlePattern: 'Meta title pattern (optional)',
        metaTitlePatternPlaceholder: 'Shopping in {city}: the local guide',
        metaTitlePatternHint: 'Same {token} tokens. Used for the page {tag}.',
        metaDescriptionPattern: 'Meta description pattern (optional)',
        metaDescriptionPatternPlaceholder: 'Discover the best shopping streets and stores in {city}.',
        metaDescriptionPatternHint: 'Same {token} tokens. Used for {tag}.',
        pages: 'Pages',
        importCsv: 'Import CSV',
        noTemplateVars: "The selected template doesn't reference any {vars}, so every row will resolve to the same slug and only one can exist. Add at least one variable to the template.",
        addRowHeading: 'Add a row',
        addPage: 'Add page',
        seo: 'SEO',
        seoCustomTitle: 'Hand-written for this page',
        seoPatternTitle: 'Following the dataset pattern',
        seoCustom: 'Custom',
        seoPattern: 'Pattern',
        deleteRow: 'Delete row',
        noPages: 'No pages yet. Add one above, or import a CSV.',
        noPattern: 'No pattern set',
        seoDialog: {
            title: 'Page SEO',
            intro: '{slug}. Leave a field empty to follow the dataset pattern, shown greyed out below it. Worth writing by hand for the pages that earn the traffic; the rest read better on the pattern than on a hundred variations of it.',
            metaTitle: 'Meta title',
            metaTitleHint: "Empty: use the dataset's meta title pattern.",
            metaDescription: 'Meta description',
            metaDescriptionHint: "Empty: use the dataset's meta description pattern. {token} tokens work here too.",
        },
        import: {
            title: 'Import CSV',
            intro: "The first line is the column header. It must contain exactly the variables the template uses: {vars}. It may also carry {metaTitle} and {metaDescription}, plus any variable the dataset's patterns reference without the template printing it. Each subsequent line is one landing page. The whole import is rejected if any row fails validation.",
            none: '(none)',
            body: 'CSV body',
            replace: 'Replace existing pages in this dataset',
            replaceHint: 'Off: append (any clashing slug is rejected). On: delete all current rows then import.',
            perRowErrors: 'Per-row errors',
            row: 'Row {line}:',
            pasteFirst: 'Paste CSV content first.',
            imported: 'Imported {n} landing pages. | Imported {n} landing page. | Imported {n} landing pages.',
            failed: 'Import failed.',
        },
    },
};
